<template>
  <div class="mt-2 mb-2">
    <v-dialog scrollable v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-layout justify-space-between>
          <v-chip
            v-if="selectedCurrencies.length === 0"
            label
            class="ma-1"
          >{{ $t('accounts.no_selected_currencies') }}</v-chip>
          <div class="scrolling-wrapper mb-2" style="display: block;">
            <v-chip label class="ma-1" v-for="(item, index) in selectedCurrencies" :key="index">
              <v-icon left @click="removeSelectedCurrency(item)">close</v-icon>
              {{item.balance}} {{item.name}}
            </v-chip>
          </div>
          <v-btn
            class="mx-2"
            fab
            dark
            small
            color="primary"
            @click="lessCurrencies()"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark>account_balance_wallet</v-icon>
          </v-btn>
        </v-layout>
      </template>

      <v-card>
        <v-card-title>{{ $t('accounts.balance_by_currencies') }}</v-card-title>
        <v-card-text style="height: 300px;">
          <div>
            <div>
              <v-btn
                v-if="auxSelectedCurrencies.length > 0"
                block
                outlined
                @click="applyFilters(true)"
              >{{ $t('accounts.remove_all_filters') }}</v-btn>
              <span v-else>{{ $t('accounts.select_currencies') }}</span>
            </div>
            <v-chip
              style="display: block"
              label
              v-model="displayCurrencies"
              class="mt-1 mb-1"
              v-for="(item, index) in displayCurrencies"
              :key="index"
              @click="addOrRemoveCurrency(item)"
            >
              <v-icon v-if="auxSelectedCurrencies.includes(item)" left>check</v-icon>
              {{item.balance}} {{item.name}}
            </v-chip>
            <v-btn
              v-if="!expandedCurrencies"
              @click="moreCurrencies()"
              class="justify-center"
              text
              block
            >
              <v-icon left>expand_more</v-icon>
              {{ $t('accounts.show_more') }}
            </v-btn>
            <v-btn v-else @click="lessCurrencies()" class="justify-center" text block>
              <v-icon left>expand_less</v-icon>
              {{ $t('accounts.show_less') }}
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialog=false">{{ $t('accounts.close') }}</v-btn>
          <v-btn text @click="applyFilters(false)">{{ $t('accounts.apply_filters') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { currencyTypes } from '@/config'
const { LEGAL } = currencyTypes

export default {
  data () {
    return {
      dialog: false,
      auxSelectedCurrencies: [],
      selectedCurrencies: [],
      displayCurrencies: [],
      expandedCurrencies: false,
    }
  },
  props: {
    currencies: Array,
  },
  methods: {
    getCurrencies () {
      var legalWithBalance = this.currencies
        .filter((i) => i.type === LEGAL && i.balance !== 0)
        .sort((a, b) => Math.abs(b.balance) - Math.abs(a.balance))
      var otherWithBalance = this.currencies
        .filter((i) => i.type !== LEGAL && i.balance !== 0)
        .sort((a, b) => Math.abs(b.balance) - Math.abs(a.balance))
      var legalWithoutBalance = this.currencies.filter(
        (i) => i.type === LEGAL && i.balance === 0
      )
      var otherWithoutBalance = this.currencies.filter(
        (i) => i.type !== LEGAL && i.balance === 0
      )
      var finalList = []
      finalList.push.apply(finalList, legalWithBalance)
      finalList.push.apply(finalList, otherWithBalance)
      finalList.push.apply(finalList, legalWithoutBalance)
      finalList.push.apply(finalList, otherWithoutBalance)
      return finalList
    },
    moreCurrencies () {
      this.expandedCurrencies = true
      this.displayCurrencies = this.getCurrencies()
    },
    lessCurrencies () {
      this.expandedCurrencies = false
      this.displayCurrencies = this.getCurrencies().splice(0, 5)
    },
    removeSelectedCurrency (currency) {
      var index1 = this.selectedCurrencies.findIndex(
        (c) => c.id === currency.id
      )
      this.selectedCurrencies.splice(index1, 1)
      var index2 = this.auxSelectedCurrencies.findIndex(
        (c) => c.id === currency.id
      )
      this.auxSelectedCurrencies.splice(index2, 1)
      this.$emit('filterByCurrencies', this.selectedCurrencies)
    },
    addOrRemoveCurrency (currency) {
      var index = this.auxSelectedCurrencies.findIndex(
        (c) => c.id === currency.id
      )
      if (index !== -1) {
        this.auxSelectedCurrencies.splice(index, 1)
      } else {
        this.auxSelectedCurrencies.push(currency)
      }
    },
    applyFilters (empty) {
      this.selectedCurrencies = []
      if (!empty) {
        this.selectedCurrencies.push.apply(
          this.selectedCurrencies,
          this.auxSelectedCurrencies
        )
      } else {
        this.auxSelectedCurrencies = []
      }
      this.dialog = false
      this.$emit('filterByCurrencies', this.selectedCurrencies)
    },
  },
}
</script>

<style lang="scss">
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

  .card {
    display: inline-block;
  }
}
</style>
